import { createFileRoute, Outlet } from "@tanstack/react-router";

import React from "react";
import { useTranslation } from "react-i18next";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import TabLayout from "src/components/base/tab-layout";
import { BackButton } from "src/components/base/button";
import SINGLE_SUBNET_CONTEXT, { SingleSubnetProvider } from "src/context/customer/subnet";

/**
 * The properties for {@link SingleSubnetView}
 */
export type TagLayout = {};

/**
 * The Layout for a single subnet
 */
function SingleSubnetView(props: TagLayout) {
    const [t] = useTranslation("customer-subnet-view");

    const { subnetId } = Route.useParams();

    return (
        <SingleSubnetProvider uuid={subnetId}>
            <SINGLE_SUBNET_CONTEXT.Consumer>
                {(ctx) => (
                    <div className={"flex flex-col gap-6"}>
                        <BackButton className={"self-start"} href={"/c/subnets/approved"}>
                            {t("button.back-to-subnet-overview")}
                        </BackButton>

                        <TabLayout
                            heading={t("heading.subnet", { subnet: ctx.subnet.name })}
                            headingDescription={ctx.subnet.description}
                            tabs={
                                <TabMenu>
                                    <Tab href={"/c/subnets/$subnetId/inbound-acls"} params={{ subnetId }}>
                                        {t("label.inbound-acls")}
                                    </Tab>
                                    <Tab href={"/c/subnets/$subnetId/outbound-acls"} params={{ subnetId }}>
                                        {t("label.outbound-acls")}
                                    </Tab>
                                </TabMenu>
                            }
                        >
                            <Outlet />
                        </TabLayout>
                    </div>
                )}
            </SINGLE_SUBNET_CONTEXT.Consumer>
        </SingleSubnetProvider>
    );
}

export const Route = createFileRoute("/_customer/c/subnets/$subnetId/_subnet")({
    component: SingleSubnetView,
});
